<template>
  <div class="rt-common-selector">
    <el-input 
      readonly 
      :placeholder="placeholder || '请选择'" 
      :disabled="disabled" 
      v-model="selectedValue" 
      @focus="showDialog">
      <i slot="suffix" class="el-input__icon el-icon-search" @click="showDialog"></i>
    </el-input>
    <rt-common-dialog 
      ref="commonDialog"
      :data-source="dataSource"
      :display-fields="displayFields"
      :value-field="valueField"
      :dialog-title="dialogTitle"
      :search-placeholder="searchPlaceholder"
      :current-value="value"
      @item-selected="handleItemSelected">
    </rt-common-dialog>
  </div>
</template>

<script>
import RtCommonDialog from "./common-dialog";

export default {
  name: "RtCommonSelector",
  props: {
    value: {
      type: String,
      required: false,
      default: ""
    },
    disabled: Boolean,
    dataSource: {
      type: Array,
      default: () => []
    },
    displayFields: {
      type: Array,
      default: () => [
        { name: "Vehicle", label: "规格型号" },
        { name: "new_product_name", label: "产品名称" },
        { name: "new_product_line", label: "产品线" }
      ]
    },
    valueField: {
      type: String,
      default: "Vehicle" // 返回的值字段
    },
    displayField: {
      type: String,
      default: "Vehicle" // 显示的字段
    },
    placeholder: String,
    dialogTitle: {
      type: String,
      default: "列表选择"
    },
    searchPlaceholder: {
      type: String,
      default: "搜索内容"
    }
  },
  components: {
    "rt-common-dialog": RtCommonDialog
  },
  data() {
    return {
      selectedValue: ""
    };
  },
  computed: {
    displayValue() {
      if (!this.value || !this.dataSource || this.dataSource.length === 0) {
        return "";
      }
      
      // 根据value查找对应的数据项
      const selectedItem = this.dataSource.find(item => item[this.valueField] === this.value);
      if (selectedItem) {
        // 返回displayField指定的字段值
        return selectedItem[this.displayField] || "";
      }
      
      return this.value;
    }
  },
  watch: {
    displayValue(newValue) {
      this.selectedValue = newValue;
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.updateDisplayValue();
      }
    },
    dataSource: {
      immediate: true,
      deep: true,
      handler() {
        this.updateDisplayValue();
      }
    }
  },
  mounted() {
    this.updateDisplayValue();
  },
  methods: {
    updateDisplayValue() {
      this.selectedValue = this.displayValue;
    },
    showDialog() {
      if (this.disabled) {
        return;
      }
      this.$refs.commonDialog.show();
    },
    handleItemSelected(val, selectedRow) {
      // val是选中项的valueField值，selectedRow是完整的选中项数据
      this.$emit("input", val);
      this.$emit("change", val);
      
      // 立即更新显示值
      if (selectedRow && selectedRow[this.displayField]) {
        this.selectedValue = selectedRow[this.displayField];
      }
    }
  }
};
</script>

<style scoped>
.rt-common-selector {
  width: 100%;
}

.el-input__icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// common-selector.vue?9ae3334c